import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import styles from "./index.module.scss";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";
import { ApiClient } from "../../../../api/client";
import { Steps } from "../../../../redux/reducers/cartReducer";
import { setStep } from "../../../../redux/action-creaters/cartOld";

export default React.memo(function Header() {
  const dispatch = useDispatch();
  const { cityName } = useSelector((state) => state.location);
  const { params } = useSelector((state) => state.cart);
  const [setDetectedCity] = useState(null);

  const cityNameNew = params.city_name || cityName;

  useEffect(() => {
    if (typeof window !== "object") {
      return;
    }

    if (!cityName) {
      const isRobot =
        window.navigator?.userAgent?.includes("yandex") ||
        window.navigator?.userAgent?.includes("google");
      if (!isRobot) {
        // eslint-disable-next-line no-use-before-define
        detectCity();
      }
    }
  }, [cityName]);

  const detectCity = async () => {
    const detectedCity = await ApiClient.dadata.detectCity();
    if (detectedCity && cityName !== detectedCity?.city) {
      setDetectedCity(detectedCity);
    }
  };

  const { step } = useSelector((state) => state.cart);
  return (
    <header>
      <div className={styles.HeaderWrapper}>
        <div className="container">
          <div className={styles.Header}>
            <Link href="/catalog/">
              <a className={styles.Back}>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 7H1M1 7L7 13M1 7L7 1"
                    stroke="#4D5761"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Вернуться к покупкам</span>
              </a>
            </Link>
            {(step === Steps.step1 || step === Steps.step2) && (
              <a
                href="#"
                className={styles.Back}
                onClick={(e) => {
                  e.preventDefault();
                  if (step === Steps.step1) {
                    dispatch(setStep(Steps.step0));
                  }
                  if (step === Steps.step2) {
                    dispatch(setStep(Steps.step1));
                  }
                }}
              >
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 7H1M1 7L7 13M1 7L7 1"
                    stroke="#4D5761"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>
                  {step === Steps.step1 && "Вернуться в корзину"}
                  {step === Steps.step2 && "Вернуться на шаг 1"}
                </span>
              </a>
            )}
            <Link href="/">
              <a className={styles.Logo}>
                <img src="/logo2.svg" />
              </a>
            </Link>

            <div className={styles.City}>
              <span>Выбран город:</span>
              <a
                onClick={() => dispatch(showPopup(popupTypes.locationNew))}
                aria-label="Выбрать город"
              >
                {cityNameNew}

                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 13L7 7L1 1"
                    stroke="#1247A5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
});
